(() => {
  const initSection = (section) => {
    if (section.dataset.goFlavoursReady) return;
    section.dataset.goFlavoursReady = "true";

    const slots = section.querySelectorAll(".go-flavours__slot");
    const dots = section.querySelectorAll(".go-flavours__dot");
    const infos = section.querySelectorAll("[data-go-flavours-info]");

    const select = (index) => {
      const toggle = (items) =>
        items.forEach((item, i) => {
          item.classList.toggle("is-active", i === index);
          item.setAttribute("aria-pressed", String(i === index));
        });
      toggle(slots);
      toggle(dots);
      infos.forEach((info, i) => {
        info.hidden = i !== index;
      });
    };

    section.querySelectorAll("[data-go-flavours-select]").forEach((control) => {
      control.addEventListener("click", () => select(Number(control.dataset.goFlavoursSelect)));
    });

    // Splashes and fruit pop in once the section scrolls into view, as in Framer.
    section.classList.add("js-go-flavours");
    const observer = new IntersectionObserver(
      (entries, currentObserver) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          section.classList.add("is-inview");
          currentObserver.disconnect();
        });
      },
      { threshold: 0.3 },
    );
    observer.observe(section);
  };

  document.querySelectorAll("[data-go-flavours]").forEach(initSection);

  document.addEventListener("shopify:section:load", (event) => {
    const section = event.target.querySelector("[data-go-flavours]");
    if (section) initSection(section);
  });

  // Selecting a flavour block in the theme editor shows that flavour.
  document.addEventListener("shopify:block:select", (event) => {
    const slot = event.target.closest(".go-flavours__slot");
    if (slot) slot.click();
  });
})();
